<template>
  <div v-if="!seeModal" class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content rounded-0">
      <div class="modal-header justify-content-center text-center border-0 pt-32 px-24 px-md-36 px-xl-96">
        <h5>{{ trans.modalLoginHeader ?? 'Manage your subscription' }}</h5>

        <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                type="button">
          <span class="icon icon-close"></span>
        </button>
      </div>

      <div class="modal-body px-24 px-md-36 px-xl-96">
        <p v-if="trans.modalLoginDescription" class="d-block text-center text-white text-lg">
          {{ trans.modalLoginDescription }}</p>

        <Form ref="form" v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
          <div class="uq-stripe-form-container row text-white">
            <div class="form-group col-12">
              <label class="form-label">{{ trans.emailLabel ?? 'Email' }} *</label>

              <Field
                  id="email-login"
                  v-model="billingPortalAccess.email"
                  aria-describedby="email"
                  class="form-control mb-16"
                  name="email"
                  type="email"
                  @keyup.enter="handleSubmit($event, generateBillingPortalAccess)"
              />

              <ErrorMessage class="invalid-feedback" name="email"/>
            </div>

            <div class="form-group col-12">
              <label class="form-label">{{ trans.passwordLabel ?? 'Password' }} *</label>

              <div class="button position-relative">
                <Field
                    id="password"
                    v-model="billingPortalAccess.password"
                    :type="showPassword ? 'text' : 'password'"
                    aria-describedby="password"
                    class="form-control position-relative mb-16"
                    name="password"
                    @keyup.enter="handleSubmit($event, generateBillingPortalAccess)"
                />

                <button :disabled="billingPortalAccess.password.length <= 0"
                    class="btn p-8 passwordButton"
                    @click="showPassword = !showPassword">

              <span :class="{'icon-eye-hide': showPassword,'icon-eye': !showPassword}"
                    class="icon"></span>
                </button>
              </div>

              <ErrorMessage class="invalid-feedback" name="password"/>
            </div>

            <div class="submit-section d-flex flex-column align-items-center mb-16">
              <p v-if="errorMessage?.length > 0" class="error mb-12 d-block text-md">
                {{ errorMessage }}
              </p>

              <button
                  :disabled="disabledButton"
                  class="btn btn-primary w-100 mb-8 mt-12"
                  type="button"
                  @click="handleSubmit($event, generateBillingPortalAccess)">
                <span v-if="!sendingEmail">{{ trans.buttonLoginLabel ?? 'Get access' }}</span>
                <span v-else>{{ trans.buttonLoadingLabel ?? 'Sending email... ' }}</span>
              </button>

              <button class="btn text-white link" @click="seeModal = true">
                <span>{{ trans.buttonForgotPassword ?? 'Forgot password... ' }}</span>
              </button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>

  <forgot-password-modal v-if="seeModal"
                         :locale="locale"
                         :trans="trans"
                         @closed="seeModal = false"
                         @modal-closed="seeModal = false">
  </forgot-password-modal>
</template>

<script>
import { ErrorMessage, Field, Form } from 'vee-validate';
import * as yup from 'yup';
import api from '@assets/js/front/checkout/api';
import ForgotPasswordModal from './ForgotPasswordModal.vue';

export default {
  name: 'VStripeLoginModal',
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
    subscriptionUrl: {
      required: true,
      type: String,
    },
  },
  components: {
    ForgotPasswordModal,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = {};

    return {
      schema,
      billingPortalAccess: {
        email: '',
        password: '',
      },

      disabledButton: false,
      sendingEmail: false,

      errorMessage: '',

      seeModal: false,
      showPassword: false,
    };
  },
  async mounted() {
    const spanish = {
      mixed: {
        required: 'El campo es obligatorio',
      },
      string: {
        email: 'Introduce un email válido',
      },
    };

    const english = {
      mixed: {
        required: 'The field is required',
      },
      string: {
        email: 'Email must be a valid email',
      },
    };

    yup.setLocale(this.locale === 'es' ? spanish : english);

    this.schema = yup.object().shape({
      email: yup.string().required().email().label('Email'),
      password: yup.string().required(),
    });
  },
  methods: {
    async generateBillingPortalAccess(formData) {
      this.errorMessage = '';

      try {
        this.disabledButton = true;
        this.sendingEmail = true;

        let data = {
          email: formData.email,
          password: formData.password,
        };

        await api.auth.login(data);

        window.location.href = !!this.subscriptionUrl ? this.subscriptionUrl : '/subscriber-information';

      } catch (e) {
        if (!!e.response?.data?.message) {
          this.errorMessage = e.response?.data?.message;
        }

        throw e;
      } finally {
        this.disabledButton = false;
        this.sendingEmail = false;
      }
    },
  },
};
</script>

<style lang="scss">
.link {
  position: relative;

  &:before {
    content: "";
    position: absolute;
    left: 1.25rem;
    bottom: 0.5rem;
    width: 0;
    height: 0.25rem;
    transition: width 0.3s ease-in-out;
    background: #fff;
  }

  &:hover {
    &:before {
      width: calc(100% - 2.5rem);
    }
  }
}

</style>
